
    import Vue from "vue";
    import Component from "vue-class-component";
    import { Prop } from "vue-property-decorator";
    import type { CutieListEntryMinimalView } from "cuties-client-components/types/api/Cutie";
    import SelectSendAdventure from "@/components/SelectSendAdventure.vue";
    import AdventureService from "@/cuties/adventures/AdventureService";
    import utils from "@/cuties/utils";
    import VueUtils from "@/cuties/VueUtils";
    import { ConfigInstance } from "@/cuties/engine/Config";
    import { Getter } from "vuex-class";
    import { AppStoreGetters } from "@/store/AppStore";
    import type { CutieStates } from "@/app/cuties/list/CutieListApiService";
    import type AdventurePreviewModel from "@/cuties/model/adventure/AdventurePreviewModel";
    import type { RequirementsPopupData } from "@/app/components/RequirementsPopup.vue";
    import RequirementsPopup from "@/app/components/RequirementsPopup.vue";

    @Component({
        components: { SelectSendAdventure, RequirementsPopup }
    })
    export default class CutieCardSendToAdventureButton extends Vue {
        @Prop({ required: true }) cutie!: CutieListEntryMinimalView & Partial<CutieStates>;
        @Prop({ required: true }) healedFromAdventureByItem!: boolean;
        @Getter(AppStoreGetters.GET_EVERY_SECOND_TICK_TIME_MS) everySecondTickTimeMs: number;

        sending = false;
        buttonMessage = "";
        showPopupAdventureSingle = false;
        requirementsPopupData: null | RequirementsPopupData = null;

        isMobile(): boolean {
            return VueUtils.isMobile();
        }

        popupClose(): void {
            this.showPopupAdventureSingle = false;
        }

        async sendToAdventure(adventure: AdventurePreviewModel): Promise<void> {
            this.sending = true;
            try {
                const { matchResult } = await AdventureService.sendToAdventure({
                    petId: this.cutie.id,
                    adventureConfigId: adventure.location.type,
                });
                utils.show_notification(this.$t("pet_send_adventure_success") + " " + matchResult);
                this.buttonMessage = this.$t("cutie_was_sent").toString();
                this.healedFromAdventureByItem = false;
            } catch (e) {
                const errorData = VueUtils.extractErrorData(e);
                const list = [...adventure.allOfConsumes, ...adventure.allOfPlayerRequirements];
                if (errorData?.error === "ERR_PLAYER_LACKS_REQUIRED_POSSESSIONS_PARAMETRIZED" && list.length ) {
                    this.requirementsPopupData = adventure;
                } else {
                    VueUtils.handleError(e);
                }
            } finally {
                this.sending = false;
            }

            this.popupClose();
        }

        cooldownTime(cooldown: number): number {
            return ConfigInstance.get_adventure_cooldown_time(cooldown);
        }

        openSendToAdventure(): void {
            this.showPopupAdventureSingle = true;
        }

        get isHealingFromAdventure(): boolean {
            return !this.isBorn
                || this.cutie.timeNextAdventure >= this.epochSeconds
                && !this.healedFromAdventureByItem;
        }

        isAdventureReady(): boolean {
            return !this.cutie.adventure
                && !this.cutie.occupation
                && !this.isHealingFromAdventure;
        }

        get isBorn(): boolean {
            return this.cutie.timeBorn < this.epochSeconds;
        }

        get epochSeconds(): number {
            return Math.ceil(this.everySecondTickTimeMs / 1000);
        }
    }
